interface RankingBenefitItemProps {
    gridClass: string;
    bg: string;
    icon: string;
    level: string | number;
    name: string;
    color: string;
    iconBoxClass?: string;
    children: React.ReactNode;
}

export default function RankingBenefitItem({
    gridClass,
    bg,
    icon,
    level,
    name,
    color,
    iconBoxClass = "MuiBox-root css-ysin3u",
    children,
}: RankingBenefitItemProps) {
    return (
        <div className={gridClass}>
            <div
                className="styles_levelItem_container__98jAn MuiBox-root css-1i27l4i"
                style={{ backgroundImage: `url("${bg}")` }}
            >
                <div className={iconBoxClass}>
                    <span
                        style={{
                            boxSizing: "border-box",
                            display: "block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "absolute",
                            inset: 0,
                        }}
                    >
                        <img
                            alt="icon"
                            src={icon}
                            decoding="async"
                            data-nimg="fill"
                            style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                padding: 0,
                                border: "none",
                                margin: "auto",
                                display: "block",
                                width: 0,
                                height: 0,
                                minWidth: "100%",
                                maxWidth: "100%",
                                minHeight: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </span>
                </div>

                <div className="MuiBox-root css-j7qwjs">
                    <span className="styles_levelItem_text__0cjo7" style={{ color }}>
                        {level}
                    </span>
                    <span className="styles_levelItem_text__0cjo7" style={{ color }}>
                        {name}
                    </span>
                </div>
            </div>

            <div className="MuiBox-root css-1hw29i9">
                <span className="styles_benefitTitle__AmGB_">Đặc quyền ưu đãi</span>
                <div className="styles_benefitDesc__XVzt2">{children}</div>
            </div>
        </div>
    );
}
